/* eslint-disable react-hooks/exhaustive-deps */
import { ArrowLeftOnRectangleIcon } from "@heroicons/react/24/outline";
import { useStore } from "../../store";
import { useEffect, useState } from "react";

const AYJBranding = ({
    userName, userTitle
}) => {
    const { employeeStore, layoutStore } = useStore();
    const [employee, setEmployee] = useState({});

    useEffect(() => {
        employeeStore.getEmployeeInfo().then((response) => {
            setEmployee(response);
        });
    }, []);

    // console.log(employee, "employeeemployeeemployee")

    return (
        <div className="text-right flex justify-end">
            <div className=" flex justify-between items-end py-3 mt-1 px-3 inline-block bg-white rounded-l-md 
                cursor-pointer border">
                {/* <a
                    target="_blank"
                    href="https://ayjsolicitors.com/">
                    <p>
                        <span className="text-sm text-[#334351] font-semibold">
                            Created by
                        </span>
                    </p>
                    <img
                        className="mt-2 mx-auto"
                        src="/ayj.png"
                        width={60}
                        height={30}
                        alt="logo" />
                </a> */}
                <div>
                    <div className="ml-3">
                        <p className="text-sm font-medium text-slate-950 group-hover:text-slate-400">{userName}</p>
                        <p className="text-xs font-medium text-black-300 group-hover:text-black-200">{userTitle}</p>
                    </div>
                </div>
                <div>
                    <img
                        className="inline-block mx-2 h-9 w-9 rounded-full"
                        src={employee.imageProfile || "/avatar.png"}
                        alt=""
                    />
                </div>
                <div className="flex items-stretch h-full">
                    <ArrowLeftOnRectangleIcon
                        onClick={(() => {
                            layoutStore.userLogout();
                        })}
                        className="ml-auto w-6 items-stretch text-red-400 cursor-pointer group-hover:text-red-500" aria-hidden="true" />
                </div>
            </div>
        </div>
    )
};
export default AYJBranding;